<template>
  <span>
    <a v-if="invoiceId" :href="invoiceUrl(invoiceId)" target="_blank">
      {{ invoiceId }}
    </a>
    <span v-if="invoice">
      <a v-if="invoice.id" :href="invoiceUrl(invoice.id)" target="_blank">
        {{ invoice.id }}
      </a>
      <span v-if="invoice.status"> ({{ invoice.status }})</span>
    </span>
  </span>
</template>
<script type="ts">
import Vue from 'vue';
import BillingProviderInvoice from '@/datatypes/billing/provider-invoice';

export default Vue.extend({
  name: 'invoice-text',
  props: {
    invoiceId: {
      type: String,
      default: '',
    },
    invoice: {
      type: BillingProviderInvoice,
      default: undefined,
    },
  },
  methods: {
    invoiceUrl(invoiceId) {
      return this.$billingProviderUrl[process.env.VUE_APP_PROVIDER].invoice(invoiceId);
    },
  },
});
</script>
